import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatYearMonth',
    standalone: false
})
export class FormatYearMonthPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value.length !== 6) {
      return 'Invalid Date';
    }

    const year = value.substring(0, 4);
    const month = value.substring(4, 6);

    const date = new Date(+year, +month - 1);
    const formattedDate = date.toLocaleString('en-AU', { month: 'long', year: 'numeric' });

    return formattedDate;
  }
}
